var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-progress-line"},[_c('div',{staticClass:"v-progress-line__progress",style:(`width: ${_vm.percent}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }